angular.module('services.adminResource', []).factory('adminResource', ['$http', '$q', function ($http, $q) {
  // local variable
  var baseUrl = '/api';
  var userUrl = baseUrl + '/admin/users';
  var subscriberUrl = baseUrl + '/admin/subscribers';
  var tagUrl = baseUrl + '/admin/tags';
  var tagSearchUrl =  baseUrl + '/admin/tags-s';
  var roleUrl = baseUrl + '/admin/roles';
  var roleSearchUrl =  baseUrl + '/admin/roles-s';
  var accountUrl = baseUrl + '/admin/accounts';
  var accountGroupUrl = baseUrl + '/admin/groups';
  var administratorUrl = baseUrl + '/admin/administrators';
  var adminGroupUrl = baseUrl + '/admin/admin-groups';
  var adminStatusesUrl = baseUrl + '/admin/statuses';
  var categoriesUrl = baseUrl + '/admin/categories';
  var menusUrl = baseUrl + '/admin/menus';
  var articlesUrl = baseUrl + '/admin/articles';
  var allauthorsUrl = baseUrl + '/admin/diagrams';
  var sportsUrl = baseUrl + '/admin/sports';
  var sportsStaticUrl = baseUrl + '/admin/sports-list';
  var languagesUrl = baseUrl + '/admin/languages-list';
  var albumsUrl = baseUrl + '/admin/albums';
  var imagesUrl = baseUrl + '/admin/images';
  
  var processResponse = function(res){
    return res.data;
  };
  var processError = function(e){
    // var msg = [];
    // if(e.status)         { msg.push(e.status); }
    // if(e.statusText)     { msg.push(e.statusText); }
    // if(msg.length === 0) { msg.push('Unknown Server Error'); }
    // return $q.reject(msg.join(' '));
    // $q.reject(e);
  };
  // public api
  var resource = {};
  resource.getStats = function(){
    return $http.get(baseUrl + '/admin').then(processResponse, processError);
  };
  // resource.search = function(query){
  //   return $http.get(baseUrl + '/admin/search', { params: { q: query }} ).then(processResponse, processError);
  // };

  // ----- subscribers api -----
  resource.findSubscribers = function(filters){
    if(angular.equals({}, filters)){
      filters = undefined;
    }
    return $http.get(subscriberUrl, { params: filters }).then(processResponse, processError);
  };
  resource.findSubscriber = function(_id){
    var url = subscriberUrl + '/' + _id;
    return $http.get(url).then(processResponse, processError);
  };

  // ----- users api -----
  resource.findUsers = function(filters){
    if(angular.equals({}, filters)){
      filters = undefined;
    }
    return $http.get(userUrl, { params: filters }).then(processResponse, processError);
  };
  resource.addUser = function(username){
    return $http.post(userUrl, { username: username }).then(processResponse, processError);
  };
  resource.findUser = function(_id){
    var url = userUrl + '/' + _id;
    return $http.get(url).then(processResponse, processError);
  };
  resource.updateUser = function(_id, data){
    var url = userUrl + '/' + _id;
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.setPassword = function(_id, data){
    var url = userUrl + '/' + _id + '/password';
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.linkAdmin = function(_id, data){
    var url = userUrl + '/' + _id + '/role-admin';
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.unlinkAdmin = function(_id){
    var url = userUrl + '/' + _id + '/role-admin';
    return $http.delete(url).then(processResponse, processError);
  };
  resource.linkAccount = function(_id, data){
    var url = userUrl + '/' + _id + '/role-account';
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.unlinkAccount = function(_id){
    var url = userUrl + '/' + _id + '/role-account';
    return $http.delete(url).then(processResponse, processError);
  };
  resource.deleteUser = function(_id){
    var url = userUrl + '/' + _id;
    return $http.delete(url).then(processResponse, processError);
  };

  // ----- accounts api -----
  resource.findMyArticles = function(filters){
    if(angular.equals({}, filters)){
      filters = undefined;
		}
    return $http.get('/api/account/my-articles', { params: filters }).then(processResponse, processError);
  };
  resource.findAccounts = function(filters){
    if(angular.equals({}, filters)){
      filters = undefined;
    }
    return $http.get(accountUrl, { params: filters }).then(processResponse, processError);
  };
  resource.addAccount = function(fullname){
    return $http.post(accountUrl, { 'name.full': fullname }).then(processResponse, processError);
  };
  resource.findAccount = function(_id){
    var url = accountUrl + '/' + _id;
    return $http.get(url).then(processResponse, processError);
  };
  resource.updateAccount = function(_id, data){
    var url = accountUrl + '/' + _id;
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.linkUser = function(_id, data){
    var url = accountUrl + '/' + _id + '/user';
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.unlinkUser = function(_id){
    var url = accountUrl + '/' + _id + '/user';
    return $http.delete(url).then(processResponse, processError);
  };
  resource.newAccountNote = function(_id, data){
    var url = accountUrl + '/' + _id + '/notes';
    return $http.post(url, data).then(processResponse, processError);
  };
  resource.newAccountStatus = function(_id, data){
    var url = accountUrl + '/' + _id + '/status';
    return $http.post(url, data).then(processResponse, processError);
  };
  resource.saveAccountGroups = function(_id, data){
    var url = accountUrl + '/' + _id + '/groups';
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.saveAccountPermissions = function(_id, data){
    var url = accountUrl + '/' + _id + '/permissions';
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.deleteAccount = function(_id){
    var url = accountUrl + '/' + _id;
    return $http.delete(url).then(processResponse, processError);
  };

  // ----- administrators api -----
  resource.findAdministrators = function(filters){
    if(angular.equals({}, filters)){
      filters = undefined;
    }
    return $http.get(administratorUrl, { params: filters }).then(processResponse, processError);
  };
  resource.addAdministrator = function(fullname){
    return $http.post(administratorUrl, { 'name.full': fullname }).then(processResponse, processError);
  };
  resource.findAdministrator = function(_id){
    var url = administratorUrl + '/' + _id;
    return $http.get(url).then(processResponse, processError);
  };
  resource.updateAdministrator = function(_id, data){
    var url = administratorUrl + '/' + _id;
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.adminLinkUser = function(_id, data){
    var url = administratorUrl + '/' + _id + '/user';
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.adminUnlinkUser = function(_id){
    var url = administratorUrl + '/' + _id + '/user';
    return $http.delete(url).then(processResponse, processError);
  };
  resource.saveAdminGroups = function(_id, data){
    var url = administratorUrl + '/' + _id + '/groups';
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.saveAdminPermissions = function(_id, data){
    var url = administratorUrl + '/' + _id + '/permissions';
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.deleteAdministrator = function(_id){
    var url = administratorUrl + '/' + _id;
    return $http.delete(url).then(processResponse, processError);
  };

  // ----- account-groups api -----
  resource.findAccountGroups = function(filters){
    if(angular.equals({}, filters)){
      filters = undefined;
    }
    return $http.get(accountGroupUrl, { params: filters }).then(processResponse, processError);
  };
  resource.addAccountGroup = function(name){
    return $http.post(accountGroupUrl, { name: name }).then(processResponse, processError);
  };
  resource.findAccountGroup = function(_id){
    var url = accountGroupUrl + '/' + _id;
    return $http.get(url).then(processResponse, processError);
  };
  resource.updateAccountGroup = function(_id, data){
    var url = accountGroupUrl + '/' + _id;
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.saveAccountGroupPermissions = function(_id, data){
    var url = accountGroupUrl + '/' + _id + '/permissions';
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.saveAccountGroupStatus = function(_id, data){
    var url = accountGroupUrl + '/' + _id + '/status';
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.saveAccountGroupCategories = function(_id, data){
    var url = accountGroupUrl + '/' + _id + '/categories';
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.newAccountGroupStatus = function(_id, data){
    var url = accountGroupUrl + '/' + _id + '/status';
    return $http.post(url, data).then(processResponse, processError);
  };
  resource.deleteAccountGroup = function(_id){
    var url = accountGroupUrl + '/' + _id;
    return $http.delete(url).then(processResponse, processError);
  };

  // ----- admin-groups api -----
  resource.findAdminGroups = function(filters){
    if(angular.equals({}, filters)){
      filters = undefined;
    }
    return $http.get(adminGroupUrl, { params: filters }).then(processResponse, processError);
  };
  resource.addAdminGroup = function(name){
    return $http.post(adminGroupUrl, { name: name }).then(processResponse, processError);
  };
  resource.findAdminGroup = function(_id){
    var url = adminGroupUrl + '/' + _id;
    return $http.get(url).then(processResponse, processError);
  };
  resource.updateAdminGroup = function(_id, data){
    var url = adminGroupUrl + '/' + _id;
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.saveAdminGroupPermissions = function(_id, data){
    var url = adminGroupUrl + '/' + _id + '/permissions';
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.deleteAdminGroup = function(_id){
    var url = adminGroupUrl + '/' + _id;
    return $http.delete(url).then(processResponse, processError);
  };

  // ----- statuses api -----
  resource.findStatuses = function(filters){
    if(angular.equals({}, filters)){
      filters = undefined;
    }
    return $http.get(adminStatusesUrl, { params: filters }).then(processResponse, processError);
  };
  resource.addStatus = function(data){
    return $http.post(adminStatusesUrl, data).then(processResponse, processError);
  };
  resource.findStatus = function(_id){
    var url = adminStatusesUrl + '/' + _id;
    return $http.get(url).then(processResponse, processError);
  };
  resource.updateStatus = function(_id, data){
    var url = adminStatusesUrl + '/' + _id;
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.deleteStatus = function(_id){
    var url = adminStatusesUrl + '/' + _id;
    return $http.delete(url).then(processResponse, processError);
  };

  // ----- articles api -----
  resource.findArticles = function(filters){
    filters = _.assign({
      limit: 20
    }, filters);

    return $http.get(articlesUrl, { params: filters }).then(processResponse, processError);
  };
  resource.findArticle = function(_id){
    var url = articlesUrl + '/' + _id;
    return $http.get(url).then(processResponse, processError);
  };
  resource.searchArticles = function (q) {
    var url = articlesUrl + '/search';
    return $http.get(url, { params: { q: q } }).then(processResponse, processError);
  };
  resource.searchMyArticles = function (q) {
    var url = baseUrl + '/account/my-articles/search';
    return $http.get(url, { params: { q: q } }).then(processResponse, processError);
  };
  resource.addArticle = function(data) {
    return $http.post(articlesUrl, data); //.then(processResponse, processError);
  };
  resource.updateArticle = function(id, data) {
    var url = articlesUrl + '/' + id;
    return $http.put(articlesUrl, data).then(processResponse, processError);
  };

  // ----- categories api -----
  resource.getCategoriesTree = function(params){
    return $http.get(baseUrl + '/admin/categoriesTree', {params: params}).then(processResponse, processError);
  };
  resource.findCategoriesByPath = function(path){
    return $http.get(baseUrl + '/admin/categoriesPath', {params: {path: path}}).then(processResponse, processError);
  };
  resource.findCategories = function(filters){
    if(angular.equals({}, filters)){
      filters = undefined;
    }
    return $http.get(categoriesUrl, {params: filters}).then(processResponse, processError);
  };
  resource.addCategory = function(data){
    return $http.post(categoriesUrl, data);//.then(processResponse, processError);
  };
  resource.findCategory = function(_id){
    var url = categoriesUrl + '/' + _id;
    return $http.get(url).then(processResponse, processError);
  };
  resource.updateCategory = function(_id, data){
    var url = categoriesUrl + '/' + _id;
    return $http.put(url, data);//.then(processResponse, processError);
  };
  resource.updateCategoryPosition = function(id, data){
    var url = categoriesUrl + '/' + id + '/updatePosition';
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.deleteCategory = function(_id){
    var url = categoriesUrl + '/' + _id;
    return $http.delete(url).then(processResponse, processError);
  };

  // ----- gallery ------
  resource.getAlbums = function(data){
    return $http.get(albumsUrl).then(processResponse, processError);
  };
  resource.getImages = function(data){
    return $http.get(imagesUrl).then(processResponse, processError);
  };
  resource.editImage = function(data){
    return $http.put(imagesUrl + '/' + data._id, data).then(processResponse, processError);
  };
  resource.deleteImage = function(id){
    return $http.delete(imagesUrl + '/' + id).then(processResponse, processError);
  };
  
  resource.addAlbum = function(data){
    return $http.post(albumsUrl, data).then(processResponse, processError);
  };
  resource.editAlbum = function(data){
    return $http.put(albumsUrl + '/' + data._id, data).then(processResponse, processError);
  };
  resource.deleteAlbum = function(id){
    return $http.delete(albumsUrl + '/' + id).then(processResponse, processError);
  };

  
  
  resource.addImage = function(data){
    return $http.post(imagesUrl, data).then(processResponse, processError);
  };

  // ----- menus api -----
  resource.getMenusTree = function(params){
    return $http.get(baseUrl + '/admin/menusTree', {params: params}).then(processResponse, processError);
  };
  resource.findMenusByPath = function(path){
    return $http.get(baseUrl + '/admin/menusPath', {params: {path: path}}).then(processResponse, processError);
  };
  resource.findMenus = function(filters){
    if(angular.equals({}, filters)){
      filters = undefined;
    }
    return $http.get(menusUrl, { params: filters }).then(processResponse, processError);
  };
  resource.updateMenuPosition = function(id, data){
    var url = menusUrl + '/' + id + '/updatePosition';
    return $http.put(url, data).then(processResponse, processError);
  };
  resource.addMenu = function(data){
    return $http.post(menusUrl, data).then(processResponse, processError);
  };

  resource.updateMenus = function(menus){
    return $http.post('/api/menus/updateOrder', menus).then(processResponse, processError);
  };

  resource.updateMenu = function(id, data){
    return $http.put(menusUrl + '/' + id, data).then(processResponse, processError);
  };
  resource.deleteMenu = function(id){
    return $http.delete(menusUrl + '/' + id).then(processResponse, processError);
  };

  // ----- tags api -----
  resource.findTags = function(filters){
    if(angular.equals({}, filters)){
      filters = undefined;
    }
    return $http.get(tagUrl, { params: filters }).then(processResponse, processError);
  };
  resource.searchTags = function(filters){
    if(angular.equals({}, filters)){
      filters = undefined;
    }
    return $http.get(tagSearchUrl, { params: filters }).then(processResponse, processError);
  };
  resource.findTag = function(_id){
    var url = tagUrl + '/' + _id;
    return $http.get(url).then(processResponse, processError);
  };
  resource.getTags = function(query){
    var params = {q: query};
    return $http.get(baseUrl + '/tags', {params: params}).then(function (res) {
      return res.data.map(function (item) {
        return {text: item.name};
      });
    }, processError);
  };

  resource.saveCarouselTags = function(tags){
    return $http.post('/api/tags/carousels/save', tags).then(processResponse, processError);
  };

  // ----- tags api -----
  resource.getCaches = function () {
    return $http.get(baseUrl + '/cache').then(processResponse, processError);
  }

  // ---- Diagrams api -----
  resource.findAllAuthors = function(query){
    var params = {q: query};
    var url = allauthorsUrl;
    console.log("-------------->>>>");
    return $http.get(url, {params:params}).then(processResponse, processError);
    //return $http.get(url +"?q=ronaldo&limit=20").then(processResponse, processError);
  };

  // ----- roles api -----
  resource.findRoles = function(filters){
    if(angular.equals({}, filters)){
      filters = undefined;
    }
    return $http.get(roleUrl, { params: filters }).then(processResponse, processError);
  };
  resource.searchRoles = function(filters){
    if(angular.equals({}, filters)){
      filters = undefined;
    }
    return $http.get(roleSearchUrl, { params: filters }).then(processResponse, processError);
  };
  resource.findRole = function(_id){
    var url = roleUrl + '/' + _id;
    return $http.get(url).then(processResponse, processError);
  };
  resource.getRoles = function(query){
    var params = {q: query};
    return $http.get(baseUrl + '/roles', {params: params}).then(function (res) {
      return res.data.map(function (item) {
        return {text: item.name};
      });
    }, processError);
  };
  // Role Types List
  resource.getRoleTypes = function(){
    return $http.get(baseUrl + '/role-types').then(processResponse, processError);
  };

  // Sports
  /*resource.getSports = function(){
    return $http.get(sportsUrl).then(processResponse, processError);
  };
  resource.getSportsListStatic = function(){
    return $http.get(sportsStaticUrl).then(processResponse, processError);
  };
  resource.findSport = function(_id){
    var url = sportsUrl + '/' + _id;
    return $http.get(url).then(processResponse, processError);
  };*/

  // Languages
  resource.getLanguages = function(){
    return $http.get(languagesUrl).then(processResponse, processError);
  };

  /*resource.resetRedis = function(){
    return $http.get('/api/redis/reset').then(processResponse, processError);
  };*/

  return resource;
}]);



// WEBPACK FOOTER //
// ./client/src/common/services/adminResource.js